export const publicPortalRequestTypes = Object.freeze({
    HealthReferral: 1,
    OnlineRegistration: 2,
});
  